import { render, staticRenderFns } from "./DraftRender.vue?vue&type=template&id=3c67b9c0"
import script from "./DraftRender.vue?vue&type=script&lang=js"
export * from "./DraftRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports